export enum SHIPPO_RATE_ATTRIBUTE_TYPE {
    fastest = 'FASTEST',
    bestValue = 'BESTVALUE',
    cheapest = 'CHEAPEST',
}
